import { createProviderClass } from "@next-core/utils/general";
import { http } from "@next-core/http";
import { isEmpty, isObject } from "lodash";
import { createSSEStream } from "@next-core/utils/general";
export const FLOW_API_PROVIDER = "core.provider-flow-api";
function hasFields(ext_fields, type) {
  return ext_fields === null || ext_fields === void 0 ? void 0 : ext_fields.some(item => item.source === type);
}
export function processExtFields(ext_fields) {
  const hasQueryParams = hasFields(ext_fields, "query");
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (hasQueryParams) {
    const hasBodyParams = hasFields(ext_fields, "body");
    if (hasBodyParams) {
      // NOTE: The args order here is different from generated SDK,
      // in SDK, it's [params, data, options]
      // But we keep the current behavior for compatibility.
      const [data, params, options] = args;
      return {
        data: data,
        options: {
          params: params,
          ...options
        }
      };
    }
    const [params, options] = args;
    return {
      data: {},
      options: {
        params: params,
        ...options
      }
    };
  }

  // only hasBodyParams or default
  const [data, options] = args;
  return {
    data,
    options: options
  };
}
export function hasFileType(request) {
  if ((request === null || request === void 0 ? void 0 : request.type) !== "object") {
    return false;
  }
  const processFields = fields => {
    return !isEmpty(fields) && fields.some(field => ["file", "file[]"].includes(field.type) || processFields(field.fields));
  };
  return processFields(request.fields);
}
export function transformFormData(data) {
  if (data instanceof FormData) {
    return data;
  }
  const formData = new FormData();
  for (const [key, value] of Object.entries(data)) {
    if (Array.isArray(value)) {
      value.forEach(v => {
        formData.append(key, v);
      });
    } else if (isObject(value) && !(value instanceof Blob) && !(value instanceof Date)) {
      Object.entries(value).forEach(_ref => {
        let [k, v] = _ref;
        formData.append(`${key}[${k}]`, v);
      });
    } else {
      formData.append(key, value);
    }
  }
  return formData;
}
export async function callFlowApi(_ref2) {
  let {
    url,
    originalUri,
    method = "GET",
    responseWrapper = true,
    ext_fields,
    request,
    isFileType,
    stream
  } = _ref2;
  const isSimpleRequest = ["get", "delete", "head"].includes(method.toLowerCase());
  const defaultOptions = isFileType ? {
    responseType: "blob"
  } : {};
  let response;
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  if (isSimpleRequest) {
    var _originalUri$match$le, _originalUri$match, _request$fields$lengt, _request$fields;
    const noParams = originalUri && (request === null || request === void 0 ? void 0 : request.type) === "object" && ((_originalUri$match$le = (_originalUri$match = originalUri.match(/:([^/]+)/g)) === null || _originalUri$match === void 0 ? void 0 : _originalUri$match.length) !== null && _originalUri$match$le !== void 0 ? _originalUri$match$le : 0) === ((_request$fields$lengt = (_request$fields = request.fields) === null || _request$fields === void 0 ? void 0 : _request$fields.length) !== null && _request$fields$lengt !== void 0 ? _request$fields$lengt : 0);
    let params;
    let options;
    if (noParams) {
      [options] = args;
    } else {
      [params, options] = args;
    }
    if (stream) {
      var _options$headers, _options;
      const stream = await createSSEStream(http.getUrlWithParams(url, params), {
        ...defaultOptions,
        ...options,
        method,
        headers: Object.fromEntries([...new Headers((_options$headers = (_options = options) === null || _options === void 0 ? void 0 : _options.headers) !== null && _options$headers !== void 0 ? _options$headers : {}).entries()])
      });
      return stream;
    }
    response = await http.simpleRequest(method, url, {
      params,
      ...defaultOptions,
      ...options
    });
  } else {
    const isUploadType = hasFileType(request);
    const result = processExtFields(ext_fields, ...args);
    const data = isUploadType ? transformFormData(result.data) : result.data;
    if (stream) {
      var _result$options;
      const {
        body,
        headers
      } = http.getBodyAndHeaders(data, (_result$options = result.options) === null || _result$options === void 0 ? void 0 : _result$options.headers);
      const stream = await createSSEStream(url, {
        ...defaultOptions,
        ...result.options,
        method,
        headers: Object.fromEntries([...new Headers(headers !== null && headers !== void 0 ? headers : {}).entries()]),
        body
      });
      return stream;
    }
    response = await http.requestWithBody(method, url, data, {
      ...defaultOptions,
      ...result.options
    });
  }
  return (isFileType ? false : responseWrapper) ? response.data : response;
}
export function registerFlowApiProvider() {
  customElements.define(FLOW_API_PROVIDER, createProviderClass(callFlowApi));
}
//# sourceMappingURL=FlowApiProvider.js.map